import axios from 'axios';
import { useEffect, useState } from 'react';
import './App.css';

// Set API base URL for production
axios.defaults.baseURL = 'https://zero-cost-app.vercel.app';

function App() {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [items, setItems] = useState([]);
  const [newItem, setNewItem] = useState({ name: '', description: '' });
  const [loginData, setLoginData] = useState({ username: '', password: '' });
  const [isRegistering, setIsRegistering] = useState(false);

  useEffect(() => {
    if (token) {
      fetchItems();
    }
  }, [token]);

  const fetchItems = async () => {
    try {
      const res = await axios.get('/items', { headers: { Authorization: `Bearer ${token}` } });
      setItems(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleAuth = async (e) => {
    e.preventDefault();
    try {
      const endpoint = isRegistering ? '/register' : '/login';
      const res = await axios.post(endpoint, loginData);
      if (!isRegistering) {
        setToken(res.data.token);
        localStorage.setItem('token', res.data.token);
      } else {
        alert('Registered successfully! Please login.');
        setIsRegistering(false);
      }
    } catch (err) {
      alert(err.response.data.error);
    }
  };

  const handleAddItem = async (e) => {
    e.preventDefault();
    try {
      await axios.post('/items', newItem, { headers: { Authorization: `Bearer ${token}` } });
      setNewItem({ name: '', description: '' });
      fetchItems();
    } catch (err) {
      console.error(err);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`/items/${id}`, { headers: { Authorization: `Bearer ${token}` } });
      fetchItems();
    } catch (err) {
      console.error(err);
    }
  };

  const logout = () => {
    setToken(null);
    localStorage.removeItem('token');
    setItems([]);
  };

  if (!token) {
    return (
      <div className="App">
        <h1>{isRegistering ? 'Register' : 'Login'}</h1>
        <form onSubmit={handleAuth}>
          <input
            type="text"
            placeholder="Username"
            value={loginData.username}
            onChange={(e) => setLoginData({ ...loginData, username: e.target.value })}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={loginData.password}
            onChange={(e) => setLoginData({ ...loginData, password: e.target.value })}
            required
          />
          <button type="submit">{isRegistering ? 'Register' : 'Login'}</button>
        </form>
        <button onClick={() => setIsRegistering(!isRegistering)}>
          {isRegistering ? 'Already have an account? Login' : 'Need an account? Register'}
        </button>
      </div>
    );
  }

  return (
    <div className="App">
      <h1>Items</h1>
      <button onClick={logout}>Logout</button>
      <form onSubmit={handleAddItem}>
        <input
          type="text"
          placeholder="Name"
          value={newItem.name}
          onChange={(e) => setNewItem({ ...newItem, name: e.target.value })}
          required
        />
        <input
          type="text"
          placeholder="Description"
          value={newItem.description}
          onChange={(e) => setNewItem({ ...newItem, description: e.target.value })}
          required
        />
        <button type="submit">Add Item</button>
      </form>
      <ul>
        {items.map((item) => (
          <li key={item.id}>
            <strong>{item.name}</strong>: {item.description}
            <button onClick={() => handleDelete(item.id)}>Delete</button>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default App;